import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "antd";
import {
  BarChartOutlined,
  BellOutlined,
  CompassOutlined,
  FileTextOutlined,
  HeartOutlined,
  SettingOutlined,
} from "@ant-design/icons";

import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import EmptyState from "../../components/empty-state/EmptyState";

// Pages that are linked from the sidebar but not built yet, keyed by path.
const PAGES = {
  "/stats": {
    icon: <BarChartOutlined />,
    title: "Stats isn't available yet",
    description:
      "This page hasn't been built. For booking and revenue figures, use the Dashboard or Finance.",
  },
  "/notifications": {
    icon: <BellOutlined />,
    title: "No notifications page yet",
    description:
      "This page hasn't been built. New booking alerts still pop up while the back office is open.",
  },
  "/system-health": {
    icon: <HeartOutlined />,
    title: "System Health isn't available yet",
    description: "This page hasn't been built, so service status isn't shown here.",
  },
  "/logs": {
    icon: <FileTextOutlined />,
    title: "Logs aren't available yet",
    description: "This page hasn't been built, so activity logs aren't shown here.",
  },
  "/settings": {
    icon: <SettingOutlined />,
    title: "Settings aren't available yet",
    description:
      "This page hasn't been built. To change your password, go to Profile.",
  },
};

const NOT_FOUND = {
  icon: <CompassOutlined />,
  title: "Page not found",
  description:
    "This address doesn't match any page in the back office. Check the link, or go back to the Dashboard.",
};

const Placeholder = () => {
  const { pathname } = useLocation();
  const page = PAGES[pathname] ?? NOT_FOUND;

  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />
        <div className="listContainer">
          <EmptyState
            icon={page.icon}
            title={page.title}
            description={page.description}
            action={
              <Link to="/">
                <Button type="primary">Go to Dashboard</Button>
              </Link>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Placeholder;
